import React, { useState } from 'react';
import { TextField, InputAdornment, List, ListItem, Paper, Popover, createTheme, ThemeProvider } from '@mui/material';
import SearchIconSVG from '../../../../assets/images/ScholarshipPage/SearchIconSVG.svg';
import { styled } from '@mui/material/styles';
import { COLOR_TEXT } from '../../../../constants/color';


const CustomTextField = styled(TextField)((props) => ({
    color: COLOR_TEXT,
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: '1.019px',
    gap: '28px !important',
    width: '100%',
    backgroundColor: props?.bgColor ? props?.bgColor : '#FFF',
    '& .MuiInputBase-input.MuiInput-input': {
        backgroundColor: props?.bgColor ? props?.bgColor : '#FFF'
    }
}));


export const SearchOption = ({ handleChange, handleSearch, handleEnterKeyPress, style, bgColor }) => {
    const [anchorE1, setAnchorE1] = useState(null);
    const handleClick = (e) => {
        setAnchorE1(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorE1(null);
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };
    const open = Boolean(anchorE1);
    const id = open ? 'simple-popover' : undefined;
    return (
        <CustomTextField
            bgColor={bgColor}
            autoComplete="off"
            fullWidth
            required
            variant="outlined"
            margin="none"
            placeholder="Search"
            onChange={handleChange}
            InputProps={{
                endAdornment: (
                    <InputAdornment
                        onClick={handleSearch}
                        position="end"
                        style={{ cursor: 'pointer', paddingRight: '10px', float: 'right' }}>
                        <img height="18px" width="18px" src={SearchIconSVG} alt="search" />
                    </InputAdornment>
                ),
                disableUnderline: true,
                style: {
                    background: 'transparent',
                },
            }}
            onFocus={handleClick}
            onBlur={handleClose}
            onKeyDown={handleKeyPress}
            style={style}
        />
    );
};
